import React from 'react';

export const dims = [
  1000, // Adjusted dimensions width
  80 // Adjusted dimensions height
];

/**
 * @param {object} props
 * @param {{ id: string, value: number, percent: number }} props.tick - tick data (required)
 * @param {number} [props.count]
 * @param {(d: number) => any} [props.format] - value formatter
 */
export default function Tick({ tick, count, format = (d) => d }) {
  const x = dims[0] * (tick.percent / 100);

  return (
    <g transform={`translate(${x},0)`} style={{ pointerEvents: 'none', zIndex: 2 }}>
      <text stroke="#333" y="30" x="30" textAnchor="middle" fontSize="40px">
        {format(tick.value)}
      </text>
    </g>
  );
}

